module.exports = __webpack_public_path__ + "img/minedu_h.f06c64a1.png";